export default {
  FLIP_COLOR_MODE: 'FLIP_COLOR_MODE',
  SET_MY_COFFEES: 'SET_MY_COFFEES',
  CLEAR_MY_COFFEES: 'CLEAR_MY_COFFEES',
  SHOW_CUPPING_SETTINGS: 'SHOW_CUPPING_SETTINGS',
  SET_MY_PUBLIC_DATA: 'SET_MY_PUBLIC_DATA',
  CLEAR_MY_PUBLIC_DATA: 'CLEAR_MY_PUBLIC_DATA',
  SET_MY_PRIVATE_DATA: 'SET_MY_PRIVATE_DATA',
  CLEAR_MY_PRIVATE_DATA: 'CLEAR_MY_PRIVATE_DATA',
  SET_ANON: 'SET_ANON',
  UID_NOT_PRESENT: 'UID_NOT_PRESENT',
  SET_EMAIL: 'SET_EMAIL',
  SET_MY_CURRENT_CUPPING: 'SET_MY_CURRENT_CUPPING',

  SHOW_HEADER_SHOP: 'SHOW_HEADER_SHOP',
  SET_LOADED: 'SET_LOADED',
  SET_UID: 'SET_UID',
  SET_USERNAME: 'SET_USERNAME',
  SET_PROFILE_PIC: 'SET_PROFILE_PIC',
  CLEAR_STATE: 'CLEAR_STATE',
  SET_AUTH_ERROR: 'SET_AUTH_ERROR',
  CLEAR_AUTH_ERROR: 'CLEAR_AUTH_ERROR',
  SET_DATE_CREATED: 'SET_DATE_CREATED',
  SET_FRIENDS: 'SET_FRIENDS',
  SET_FRIEND_DATA: 'SET_FRIEND_DATA',
}


// WEBPACK FOOTER //
// ./src/services/AUTH/mutations/types.js